import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index', 'fileType', 'paymentFolio']);
  const modifyBatchPaymentFileConfig = `modifyBatchPaymentFileConfig(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyBatchPaymentFileConfig} {
      id
    }
  }
`;
};
